export default "__VITE_ASSET__NROV1_SX__"